module.exports = {
	"genre": {
		"genre-id-1": "Miscellaneous",
		"genre-id-2": "Blues/Country/Folk",
		"genre-id-3": "Blues",
		"genre-id-4": "Country",
		"genre-id-5": "Folk",
		"genre-id-6": "French Music",
		"genre-id-7": "French Music interpreters",
		"genre-id-8": "Retro French Music",
		"genre-id-9": "French Rock",
		"genre-id-10": "Classical",
		"genre-id-11": "Electronic or Concrète",
		"genre-id-12": "Musique Concrète",
		"genre-id-13": "Electro",
		"genre-id-14": "Minimal Music",
		"genre-id-15": "Mélodies & Lieder",
		"genre-id-16": "Lieder (Germany)",
		"genre-id-17": "Lieder",
		"genre-id-18": "Mélodies",
		"genre-id-19": "Mélodies (England)",
		"genre-id-20": "Mélodies (Northern Europe)",
		"genre-id-21": "Mélodies (France)",
		"genre-id-22": "Concertos",
		"genre-id-23": "Other instruments",
		"genre-id-24": "Keyboard Concertos",
		"genre-id-25": "Violin Concertos",
		"genre-id-26": "Cello Concertos",
		"genre-id-27": "Chamber Music",
		"genre-id-28": "Other formations",
		"genre-id-29": "Other solo instruments",
		"genre-id-30": "Piano solo",
		"genre-id-31": "Quartets",
		"genre-id-32": "Quintets",
		"genre-id-33": "Duos",
		"genre-id-34": "Trios",
		"genre-id-35": "Violon Solos",
		"genre-id-36": "Cello Solos",
		"genre-id-37": "Symphonic Music",
		"genre-id-38": "Ballets",
		"genre-id-39": "Theatre Music",
		"genre-id-40": "Cinema Music",
		"genre-id-41": "Overtures",
		"genre-id-42": "Symphonic Poems",
		"genre-id-43": "Symphonies",
		"genre-id-44": "Vocal Music (Secular and Sacred)",
		"genre-id-45": "Cantatas (Secular)",
		"genre-id-46": "Choral Music (Choirs)",
		"genre-id-47": "Music by vocal ensembles",
		"genre-id-48": "Secular Oratorios",
		"genre-id-49": "Vocal Recitals",
		"genre-id-50": "Sacred Vocal Music",
		"genre-id-51": "Sacred Cantatas",
		"genre-id-52": "Sacred Choirs",
		"genre-id-53": "Masses, Passions, Requiems",
		"genre-id-54": "Sacred Oratorios",
		"genre-id-55": "Opera",
		"genre-id-56": "Opera Extracts",
		"genre-id-57": "Full Operas",
		"genre-id-58": "Operettas",
		"genre-id-59": "Comedy/Other",
		"genre-id-60": "Educational",
		"genre-id-61": "Historical Documents",
		"genre-id-62": "Humour",
		"genre-id-63": "Litterature",
		"genre-id-64": "Electronic",
		"genre-id-65": "Ambient",
		"genre-id-66": "Downtempo",
		"genre-id-67": "Drum & Bass",
		"genre-id-68": "House",
		"genre-id-69": "Lounge",
		"genre-id-70": "Techno",
		"genre-id-71": "Trance",
		"genre-id-72": "Trip Hop",
		"genre-id-73": "Children Ambient",
		"genre-id-74": "Accordion",
		"genre-id-75": "Stories and Nursery Rhymes",
		"genre-id-76": "Educational",
		"genre-id-77": "Karaoke",
		"genre-id-78": "Military Music",
		"genre-id-79": "Relaxation",
		"genre-id-80": "Jazz",
		"genre-id-81": "Be Bop",
		"genre-id-82": "Cool jazz",
		"genre-id-83": "Free Jazz & Avant-Garde",
		"genre-id-84": "Gospel",
		"genre-id-85": "Contemporary Jazz",
		"genre-id-86": "Jazz Fusion & Jazz Rock",
		"genre-id-87": "Gypsy Jazz",
		"genre-id-88": "Traditional Jazz & New Orleans",
		"genre-id-89": "Vocal Jazz",
		"genre-id-90": "Latin jazz",
		"genre-id-91": "Soundtracks",
		"genre-id-92": "Film Soundtracks",
		"genre-id-93": "Musical Theatre",
		"genre-id-94": "World",
		"genre-id-95": "Africa Music",
		"genre-id-96": "Afrobeat",
		"genre-id-97": "Asia Music",
		"genre-id-98": "Brazil",
		"genre-id-99": "Celtic Music",
		"genre-id-100": "Eastern Europe Music",
		"genre-id-101": "Fado",
		"genre-id-102": "Flamenco",
		"genre-id-103": "Ethnic Music",
		"genre-id-104": "Indian Music",
		"genre-id-105": "Oriental Music",
		"genre-id-106": "Raï",
		"genre-id-107": "Salsa",
		"genre-id-108": "Tango",
		"genre-id-109": "World Music",
		"genre-id-110": "Yiddish & Klezmer",
		"genre-id-111": "Zouk & Antilles",
		"genre-id-112": "Pop/Rock",
		"genre-id-113": "Alternative & Indie",
		"genre-id-114": "Crooners",
		"genre-id-115": "Hard Rock",
		"genre-id-116": "Metal",
		"genre-id-117": "Pop",
		"genre-id-118": "Punk - New Wave",
		"genre-id-119": "Rock",
		"genre-id-120": "Progressive Rock",
		"genre-id-121": "Rockabilly",
		"genre-id-122": "International Pop",
		"genre-id-123": "Reggae",
		"genre-id-124": "Dancehall",
		"genre-id-125": "Dub",
		"genre-id-126": "Ska & Rocksteady",
		"genre-id-127": "Soul/Funk/R&B",
		"genre-id-128": "Acid jazz",
		"genre-id-129": "Dance",
		"genre-id-130": "Disco",
		"genre-id-131": "Funk",
		"genre-id-132": "R&B",
		"genre-id-133": "Hip-Hop/Rap",
		"genre-id-134": "Soul",
		"genre-id-135": "Operettas",
		"genre-id-137": "Concertos for trumpet",
		"genre-id-138": "Concertos for Wind Instruments",
		"genre-id-139": "Crossover",
		"genre-id-140": "Documents",
		"genre-id-141": "New Age",
		"genre-id-142": "Ambient",
		"genre-id-144": "Crossover",
		"genre-id-145": "Dixieland",
		"genre-id-146": "Ragtime",
		"genre-id-147": "TV Series",
		"genre-id-148": "Video Games",
		"genre-id-149": "Latin",
		"genre-id-150": "North America Music",
		"genre-id-151": "European Music",
		"genre-id-152": "Gypsy",
		"genre-id-153": "Traditional Music",
		"genre-id-154": "Maghreb Music",
		"genre-id-155": "Russia Music",
		"genre-id-156": "Turkey Music",
		"genre-id-157": "Indie Pop",
		"genre-id-158": "Bawdy songs",
		"genre-id-159": "Christmas Music",
		"genre-id-160": "German Music",
		"genre-id-161": "Scotland Music",
		"genre-id-162": "Spain Music",
		"genre-id-163": "Greece Music",
		"genre-id-164": "Ireland Music",
		"genre-id-165": "Italian Music",
		"genre-id-166": "Portugal Music",
		"genre-id-167": "Children",
		"genre-id-176": "Secular Vocal Music",
		"genre-id-173": "Schlager",
		"genre-id-171": "Stimmungsmusik",
		"genre-id-172": "Volksmusik",
		"genre-id-174": "Irish Celtic Music",
		"genre-id-175": "Irish Pop Music",
		"genre-id-168": "Swiss Folk Music",
		"genre-id-178": "German",
		"genre-id-177": "English",
		"genre-id-170": "French",
		"genre-id-179": "Dutch",
		"genre-id-180": "Bolero",
		"genre-id-181": "Latin Urban",
		"genre-id-182": "Reggaeton",
		"genre-id-183": "MPB",
		"genre-id-184": "Bossa Nova",
		"genre-id-185": "Samba",
		"genre-id-186": "Forro",
		"genre-id-187": "Pagode",
		"genre-id-188": "Brazilian Funk",
		"genre-id-189": "Sertanejo",
		"genre-id-190": "Japanese music",
		"genre-id-191": "J-Pop",
		"genre-id-192": "Japanese traditional",
		"genre-id-193": "Korean music",
		"genre-id-194": "K-Pop",
		"genre-id-195": "Korean traditional",
		"genre-id-196": "Anime/Video game",
		"genre-id-197": "Anime"
	},
	"article-cat": {
		"article-cat-2": "-- GENERAL ARCHIVES --",
		"article-cat-4": "Interviews",
		"article-cat-5": "-- GENERAL ARCHIVES --",
		"article-cat-7": "On Stage",
		"article-cat-8": "Nominations and Awards",
		"article-cat-10": "In the media",
		"article-cat-22": "Dear Missing",
		"article-cat-51": "Discography",
		"article-cat-53": "Bibliography",
		"article-cat-54": "Portraits",
		"article-cat-97": "News",
		"article-cat-98": "Main headings",
		"article-cat-100": "Industries",
		"article-cat-101": "New Releases",
		"article-cat-117": "Jazz News",
		"article-cat-122": "News",
		"article-cat-189": "Interview",
		"article-cat-197": "Comparative listening",
		"article-cat-199": "Interviews",
		"article-cat-209": "My memory is fading",
		"article-cat-226": "Cave Canem",
		"article-cat-227": "Fortissimo",
		"article-cat-229": "Can you?",
		"article-cat-238": "Magazine: reviews",
		"article-cat-252": "Callassotherapy",
		"article-cat-260": "The symphoman",
		"article-cat-267": "Crossraoads",
		"article-cat-279": "Concerts",
		"article-cat-286": "Confidential",
		"article-cat-287": "Agenda",
		"article-cat-293": "Events",
		"article-cat-295": "Concerts and tours",
		"article-cat-297": "Hi-Fi",
		"article-cat-298": "Testing Ground",
		"article-cat-299": "Practical",
		"article-cat-301": "News",
		"article-cat-302": "Exceptional sound recordings",
		"article-cat-303": "The Sound Wizards",
		"article-cat-304": "Trax",
		"article-cat-305": "Old wax in clean ears",
		"article-cat-306": "Voxpop",
		"article-cat-311": "Berlin Philharmonic Orchestra",
		"article-cat-312": "André Tubeuf: Memories and Landscapes",
		"article-cat-315": "François Hudry: Cum grano salis",
		"article-cat-316": "Qibuz Classical",
		"article-cat-318": "Editorials",
		"article-cat-319": "Qobuz at",
		"article-cat-320": "Marseilles",
		"article-cat-321": "Paris Baroque Festival",
		"article-cat-322": "Hi-Fi addicts",
		"article-cat-323": "Rennes",
		"article-cat-324": "Editorials",
		"article-cat-325": "Qibuz",
		"article-cat-326": "Jean-Michel Proust's editorial",
		"article-cat-327": "Jean-Michel Proust: the news of the month",
		"article-cat-328": "Qibuz Monday",
		"article-cat-329": "Lille",
		"article-cat-330": "Yes Masters!",
		"article-cat-331": "The Qobuz Minute",
		"article-cat-332": "Modern",
		"article-cat-333": "Newsletters",
		"article-cat-334": "Qobuz Weekly Newsletter",
		"article-cat-335": "Promotional Newsletters",
		"article-cat-336": "Qobuz Hi-Fi Newsletter",
		"article-cat-337": "Classical Newsletter",
		"article-cat-339": "Electronic Newsletter",
		"article-cat-340": "Children Newsletter",
		"article-cat-341": "Humour/Spoken Word Newsletter",
		"article-cat-342": "HD audio compatible smartphones",
		"article-cat-343": "French Music Newsletter",
		"article-cat-344": "France Musique",
		"article-cat-345": "Modern Style",
		"article-cat-347": "Ambient Newsletter",
		"article-cat-350": "In English",
		"article-cat-351": "In German",
		"article-cat-352": "In Dutch",
		"article-cat-353": "In English",
		"article-cat-354": "In German",
		"article-cat-355": "In Dutch",
		"article-cat-356": "In Dutch",
		"article-cat-357": "In German",
		"article-cat-358": "In English",
		"article-cat-359": "Old Sequins and Old Breastplates",
		"article-cat-360": "Hannah Krooz",
		"article-cat-361": "Tutorials",
		"article-cat-362": "Classical New Releases",
		"article-cat-363": "Qobuz Studio",
		"article-cat-364": "Qobuz Studio",
		"article-cat-365": "Top stories",
		"article-cat-368": "Archive",
		"article-cat-369": "Qobuz Chef",
		"article-cat-370": "One Cover / One Word"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/apiLocale/apiEn.json
// module id = 557
// module chunks = 0